import React from "react";
import { Box, Button, Flex, Text } from "rebass";
import { Backdrop, Block, Overlay, styled } from "reakit";

const HealthFormReminder = (props) => {
  const { visible, handleConfirm } = props;
  const NewBackdrop = styled(Backdrop)`
    z-index: 9999 !important;
  `;
  return (
    <Overlay.Container>
      {(overlay) => (
        <Block>
          <NewBackdrop
            fade
            use={Overlay.Hide}
            {...overlay}
            visible={visible}
            onClick={props.toggle}
          />
          <Overlay fade {...overlay} visible={visible} width={"80vw"}>
            <Flex flexDirection={"column"} justifyContent={"space-between"}>
              <Box>
                <Text textAlign={"center"}>
                  Reminder: You have not submitted your daily health form for
                  today.
                </Text>
              </Box>
              <Flex justifyContent={"center"}>
                <Button
                  variant={"second"}
                  p={1}
                  m={1}
                  bg={"green"}
                  onClick={handleConfirm}
                >
                  Take me there
                </Button>
              </Flex>
            </Flex>
          </Overlay>
        </Block>
      )}
    </Overlay.Container>
  );
};

export default HealthFormReminder;
